import { Cart } from '@/models/cart/cart'
import { CartItem } from '../cart-item'

export const itemShouldExistInCart = (item: CartItem, cart: Cart): void => {
  if (cart.items.contain(item)) {
    return
  }

  throw new CartItemNotFoundInCartError(`cart item ${item.id} not found in cart`)
}

class CartItemNotFoundInCartError extends Error { }
